module.exports = __webpack_public_path__ + "img/shopify-limitations-for-e-commerce.ea08511f.webp";